export default {
	game: {
		maintenance: 'Maintenance',
		maintenance_tip: 'Pansamantalang hindi available',
		no_more_data: 'Walang karagdagang data',
		search_game_name: 'Hanapin ang pangalan ng game...',
		selected: 'Napili',
		type: 'Uri',
		all_types: 'Lahat ng Uri',
		secondary: 'Pangalawa',
		secondary_category: 'Pangalawang Kategorya',
		no_related_games: 'Walang nakitang kaugnay na laro',
		reset_all: 'I-reset Lahat',
		end_of_list: 'Katapusan ng Listahan',
		game_details: 'Mga Detalye ng Laro',
		play: 'Laro',
		bonus_cannot_wagered: 'Hindi pwedeng i-bet ang Bonus',
		entering_game: 'Papasok sa game, mangyaring maghintay...',
		entering_game_short: 'Papasok sa Game...',
		game_types: 'Mga Uri ng Laro',
		game_providers: 'Mga Provider ng Laro',
		sign_up: 'Mag-sign Up',
		search: 'Maghanap',
		all_providers: 'Lahat ng Provider',
		loading: 'Naglo-load...',
		my_bet: 'Aking Bet'
	}
};